import { faHome, faPlaneDeparture, IconDefinition } from "@fortawesome/free-solid-svg-icons"
import { CATEGORY_ID, IProduct } from "./products"

export type Person = {
    firstname: string
    lastname: string
    email: string
    phone: string
}

export const emptyPerson: Person = {
    email: "",
    firstname: "",
    lastname: "",
    phone: ""
}

export type Category = {
    id: number
    name: string
    icon: IconDefinition
}
export const categories: Category[] = [
    {
        id: CATEGORY_ID.depto,
        name: "Departamento",
        icon: faHome
    },
    {
        id: CATEGORY_ID.luna,
        name: "Luna de miel",
        icon: faPlaneDeparture
    }
]

export type Sorter = {
    id: number
    name: string
    sort: (a: IProduct, b: IProduct) => number
}
export const sorters: Sorter[] = [
    {
        id: 2,
        name: "Nombre A-Z",
        sort: (a, b) => a.name.localeCompare(b.name)
    },
    {
        id: 3,
        name: "Nombre Z-A",
        sort: (a, b) => -a.name.localeCompare(b.name)
    },
    {
        id: 0,
        name: "Precio mayor a menor",
        sort: (a, b) => b.price - a.price
    },
    {
        id: 1,
        name: "Precio menor a mayor",
        sort: (a, b) => a.price - b.price
    }
]